import { render, staticRenderFns } from "./ChartTitleUpdate.vue?vue&type=template&id=36d6e375&scoped=true&"
import script from "./ChartTitleUpdate.vue?vue&type=script&lang=js&"
export * from "./ChartTitleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ChartTitleUpdate.vue?vue&type=style&index=0&id=36d6e375&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d6e375",
  null
  
)

export default component.exports